<!-- ================劳动实践馆-四季主题====================-->
<template>
    <div class="laborSeason-offline-page">
        <home-head />
        <div class="laborSeason-offline-body">
            <div class="laborSeason-offline-inner">
                <div class="laborSeason-offline-header">
                    <div class="laborSeason-offline-title-box">
                        <div class="laborSeason-offline-title">四季劳动主题活动</div>
                        <div class="laborSeason-offline-subtitle">四季耕读、劳动砺心</div>
                    </div>
                    <div class="laborSeason-offline-actions">
                        <div class="back-btn" @click="goBack">
                            <span class="back-arrow">←</span>
                            <span>返回</span>
                        </div>
                    </div>
                </div>

                <div class="laborSeason-offline-cards">
                    <div class="laborSeason-offline-card cursor" v-for="(item, index) in categoryList" :key="index" @click="handleCategory(item)">
                        <div class="laborSeason-offline-card-box">
                            <div class="laborSeason-offline-card-main">
                                <div class="laborSeason-offline-card-month">{{ item.itemMonth }}</div>
                                <div class="laborSeason-offline-card-theme">{{ item.itemName }}</div>
                            </div>
                            <div class="laborSeason-offline-card-desc">{{ item.itemDesc }}</div>
                            <div class="laborSeason-offline-card-desc">&nbsp;</div>
                            <div class="laborSeason-offline-card-desc">&nbsp;</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {listItem} from "@/api/admin/item"
import homeHead from "@/components/common/homeHead.vue";
export default {
    components: {homeHead},
    name: "laborSeason",
    data() {
        return {
            searchKeyword: "",
            categoryList: [],
            queryItemForm:{
                itemType:'4',
                museumKey:'4',
            },
        }
    },
    computed: {},
    watch: {},
    created() {
        this.queryItemList();
    },
    mounted() {},
    methods: {
        /* ===============数据查询===================== */
        queryItemList(){
            listItem(this.queryItemForm).then(res => {
                if (res.data.code===1){
                    this.categoryList = res.data.data;
                }else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        /* ===============跳转===================== */
        handleSearch(){
            this.$message.success("搜索：" + this.searchKeyword)
        },
        goBack(){
            this.$router.back();
        },
        handleCategory(item){
            this.$router.push({
                path: "/museum/labor/seasonPage",
                query: { item: item.itemId },
            });
        }
    }
}
</script>

<style scoped>
.laborSeason-offline-page{
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.laborSeason-offline-body{
    flex: 1;
    min-height: 0;
    width: 100%;
    background-color: #fdfcf8;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 30px 0;
    box-sizing: border-box;
    overflow: hidden;
}
.laborSeason-offline-inner{
    width: 100%;
    max-width: 1200px;
    height: 100%;
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}
.laborSeason-offline-header{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    flex-shrink: 0;
}
.laborSeason-offline-title-box{
    display: flex;
    flex-direction: column;
}
.laborSeason-offline-title{
    font-size: 20px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    letter-spacing: 2px;
    margin-bottom: 8px;
}
.laborSeason-offline-subtitle{
    font-size: 14px;
    color: #9ca3af;
    font-family: sans-serif;
    letter-spacing: 1px;
}
.laborSeason-offline-actions{
    display: flex;
    align-items: center;
    gap: 12px;
}
.search-input{
    width: 180px;
    height: 32px;
    line-height: 32px;
    padding: 0 10px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    outline: none;
    font-size: 13px;
    font-family: sans-serif;
    box-sizing: border-box;
}
.search-input:focus{
    border-color: #b22222;
}
.search-btn{
    height: 32px;
    line-height: 32px;
    padding: 0 18px;
    border: 1px solid #b22222;
    border-radius: 4px;
    font-size: 13px;
    color: #b22222;
    background-color: #ffffff;
    font-family: sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
}
.search-btn:hover{
    background-color: #b22222;
    color: #ffffff;
}
.back-btn{
    height: 32px;
    line-height: 32px;
    padding: 0 26px;
    background-color: #b22222;
    color: #ffffff;
    border-radius: 4px;
    font-size: 14px;
    font-family: sans-serif;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.2s ease;
}
.back-btn:hover{
    background-color: #9a1b1b;
}
.back-arrow{
    margin-right: 6px;
    font-size: 16px;
}
.laborSeason-offline-cards{
    width: 100%;
    flex: 1;
    min-height: 0;
    margin-bottom: 40px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(2, 1fr);
    gap: 20px;
    box-sizing: border-box;
}

.laborSeason-offline-card{
    min-width: 0;
    min-height: 0;
    background-color: #ffffff;
    border: 1.5px solid #b22222;
    border-radius: 4px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 3px;
    cursor: pointer;
    transition: all 0.25s ease;
}
.laborSeason-offline-card:hover{
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0,0,0,0.1);
}
.laborSeason-offline-card-box{
    width: 100%;
    height: 100%;
    border: 1px solid #e99d42;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}

.laborSeason-offline-card-main{
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
}
.laborSeason-offline-card-month{
    font-size: 20px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    margin-bottom: 6px;
}
.laborSeason-offline-card-theme{
    font-size: 18px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
}
.laborSeason-offline-card-desc{
    font-size: 12px;
    color: #e99d42!important;
    font-family: sans-serif;
    text-align: center;
    line-height: 2.4;
}
@media (max-width: 1280px) {
    .laborSeason-offline-inner { padding: 0 20px; }
    .laborSeason-offline-cards { gap: 16px; margin-bottom: 30px; }
    .laborSeason-offline-card { padding: 3px 3px; }
    .laborSeason-offline-card-month { font-size: 18px; }
    .laborSeason-offline-card-theme { font-size: 16px; }
    .laborSeason-offline-card-desc { font-size: 11px; }
}
@media (max-width: 1024px) {
    .laborSeason-offline-title { font-size: 16px; }
    .laborSeason-offline-subtitle { font-size: 12px; }
    .search-input { width: 140px; }
    .back-btn { padding: 0 18px; font-size: 13px; }
    .laborSeason-offline-cards { gap: 12px; margin-bottom: 20px; }
    .laborSeason-offline-card { padding: 3px 3px; }
    .laborSeason-offline-card-month { font-size: 14px; }
    .laborSeason-offline-card-theme { font-size: 13px; }
    .laborSeason-offline-card-desc { font-size: 10px; }
}
</style>
